<template>
  <v-container fluid class="property-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/property/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="properties-table"
              show-select
              single-select
              item-key="_id"
              sort-by="propertyrank"
              :footer-props="footer"
              :headers="headers"
              :items="properties"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Property?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteProperty.propertyname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteProperty)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.propertyimage="{ item }">
                    <v-img
                    v-if="item.propertyimage" 
                    v-bind:src="item.propertyimage"
                    max-height="80"
                    max-width="80"
                  ></v-img>
              </template>
              <template v-slot:item.propertyname="{ item }">
                <p class="two-line"><a class="primaryConst--text">{{ item.propertycode }}</a></p>
                <p class="two-line"><a class="primaryConst--text">{{ item.propertyname }}</a></p>
                <p class="two-line">{{ item.propertyinfo }}</p>
              </template>
              <template v-slot:item.propertystatus="{ item }">
                <v-chip
                  :color="getStatusColor(item.propertystatus)"
                  small>
                  {{ item.propertystatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config";
import { mapState, mapActions } from 'vuex';
import { getStatusColor } from '../../../util/tools';

export default {
  name: 'propertyList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      deleteProperty: {},
      headers: [
        { text: 'Image', value: 'propertyimage', sortable: false, width: '10%' },
        { text: 'Rank', value: 'propertyrank', width: '5%'},
        { text: 'Type', value: 'propertytype', width: '20%'  },
        { text: 'Name', value: 'propertyname' },
        { text: 'Status', value: 'propertystatus', width: '10%'  },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('Property', ['properties', 'isReceiving', 'isDeleting', 'idToDelete', 'propertiesMessage', 'isUpdating']),
  },
  methods: {
    ...mapActions('Property', ["getPropertiesRequest","deletePropertyRequest","updatePropertyRequest","createPropertyRequest"
    ]),
    editItem(item) {
      this.$router.push({ name: 'PropertyEdit', params: item })
    },
    deleteItem(item) {
      this.deletePropertyRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteProperty = {
        _id: item._id,
        propertyname: item.propertyname,
      }
    },
  },
  async created () {
    await this.getPropertiesRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
